/**
 * Renders the 6 wizard steps as a horizontal stepper.
 *
 * Each node renders both its step icon and a check mark; CSS crossfades
 * between them based on the "done" class, so no icon swap happens here. The
 * connector between two nodes fills from the left once its left node is done.
 */

import React from "react";
import { useLang } from "../i18n";

const STEP_ICONS = ["ic-step-space", "ic-step-landscape", "ic-step-package", "ic-step-artifacts", "ic-step-config", "ic-step-review"];

export default function Stepper({ active, onJump }) {
  const { t } = useLang();
  return (
    <div className="stepper">
      {STEP_ICONS.map((icon, i) => {
        const done = i < active;
        const isActive = i === active;
        const clickable = typeof onJump === "function" && (done || isActive);
        return (
          <React.Fragment key={icon}>
            {i > 0 && <div className={"step-connector" + (i <= active ? " filled" : "")} />}
            <div className={"step" + (isActive ? " is-active" : "")}>
              <div
                className={"step-node" + (done ? " done" : "") + (isActive ? " active" : "")}
                tabIndex={clickable ? 0 : -1}
                role={clickable ? "button" : undefined}
                onClick={clickable ? () => onJump(i) : undefined}
                style={clickable ? { cursor: "pointer" } : undefined}
              >
                <svg className="ic ic-20 icon-num"><use href={"#" + icon} /></svg>
                <svg className="ic ic-20 icon-check"><use href="#ic-check" /></svg>
              </div>
              <div className="step-txt">
                <div className="l1"><span className="no">{i}</span>{t("step" + i + ".l1")}</div>
                <div className="l2">{t("step" + i + ".l2")}</div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
